<template>
  <div>
    <v-card>
      <v-card-title>Chat Group Table</v-card-title>
      <v-row>
        <v-col>
          <v-data-table class="ml-6 mr-6" :items="items" :headers="headers">
            <template v-slot:item.edit="{ item }">
              <div>
                <v-btn
                  class="mx-2"
                  elevation="0"
                  fab
                  small
                  @click="editChatGroup(item)"
                >
                  <v-icon color="primary">
                    {{ icons.mdiPencil }}
                  </v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>

    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>Modifier le groupe de chat</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="editGroup.name"
            label="Nom du groupe"
            outlined
            hide-details
            readonly
          ></v-text-field>
          <v-row
            v-for="(param, index) in editGroup.parameters"
            :key="index"
            class="mt-3 outlined-row"
          >
            <!-- Bloc catégorie -->
            <template
              v-if="
                param.gtrends_category_id !== null &&
                param.gtrends_category_id !== undefined
              "
            >
              <v-col cols="12" md="5">
                <v-select
                  v-model="param.gtrends_category_id"
                  :items="categories"
                  item-text="rmr_cat_name"
                  item-value="id"
                  label="Catégorie"
                  outlined
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" md="5">
                <v-text-field
                  v-model="param.sv"
                  label="Volume de recherche"
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
            </template>

            <!-- Bloc mots-clés -->
            <template v-else-if="param.gtrends_keywords_id !== undefined">
              <v-col cols="12" md="5">
                <v-select
                  v-model="param.gtrends_keywords_id"
                  :items="keywords"
                  item-text="name"
                  item-value="id"
                  label="Keywords"
                  outlined
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" md="5">
                <v-text-field
                  readonly
                  label="Volume de recherches"
                  outlined
                  hide-details
                  value="0 - Non Disponible"
                ></v-text-field>
              </v-col>
            </template>
            <v-col cols="12" md="2" class="d-flex align-center">
              <v-btn
                class="mx-2"
                elevation="0"
                fab
                small
                @click="removeParameter(index)"
              >
                <v-icon color="red">
                  {{ icons.mdiTrashCan }}
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <!-- Mots clés ds v-for v-if != []-->
        </v-card-text>
        <v-card-actions>
          <v-row class="w-100" justify="start" align="center">
            <v-col cols="auto">
              <v-btn color="primary" @click="addCategory">
                Ajouter une catégorie
              </v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn color="primary" @click="addKeyword">
                Ajouter un mot-clé
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto">
              <v-btn color="primary" @click="saveChatGroup">Enregistrer</v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn color="secondary" @click="dialog = false">Annuler</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="showSuccessMessage" color="success" timeout="3000" top>
      Modification enregistrée
    </v-snackbar>
  </div>
</template>
<script>
import useAxios from "@/hooks/useAxios";
import { mdiPencil, mdiTrashCan } from "@mdi/js";
export default {
  name: "chatGroupTable",
  data() {
    return {
      showSuccessMessage: false,
      items: [],
      headers: [
        { text: "ID", value: "id" },
        { text: "Name", value: "name" },
        { text: "Edit", value: "edit" },
      ],
      icons: {
        mdiPencil,
        mdiTrashCan,
      },
      dialog: false,
      editGroup: {
        id: "",
        name: "",
        parameters: [],
      },
      categories: [],
      keywords: [],
    };
  },
  setup() {
    const { axiosGet, axiosPost, isLoading } = useAxios();

    return {
      axiosGet,
      isLoading,
      axiosPost,
    };
  },
  created() {
    this.getChatGroups();
    this.fetchCategories();
    this.fetchKeywords();
  },
  methods: {
    async fetchKeywords() {
      const response = await this.axiosGet("/gtrends/keywords");
      this.keywords = response.data;
    },
    async fetchCategories() {
      const response = await this.axiosGet("/gtrends/categories");
      this.categories = response.data;
    },
    async getChatGroups() {
      const res = await this.axiosGet("gtrends/chatgroups");
      this.items = res.data;
    },
    // Affiche l état ds la db
    async editChatGroup(item) {
      const res = await this.axiosGet(
        `gtrends/get_chat_group_params/${item.id}`
      );
      this.editGroup.id = item.id;
      this.editGroup.name = item.name;
      this.editGroup.parameters = res.data;
      this.dialog = true;
    },
    async saveChatGroup() {
      this.editGroup.parameters = this.editGroup.parameters.filter((p) =>
        Object.values(p).some((v) => v !== "")
      );
      const res = await this.axiosPost(
        `gtrends/save_chat_group_params/${this.editGroup.id}`,
        { params: this.editGroup.parameters }
      );
      this.dialog = false;
      console.log(res);
      if (res.data.status == "error") {
        alert("Erreur détectée");
      } else {
        this.showSuccessMessage = true;
      }
      this.getChatGroups();
    },
    removeParameter(index) {
      this.editGroup.parameters.splice(index, 1);
    },
    addCategory() {
      this.editGroup.parameters.push({
        gtrends_category_id: "",
        sv: "",
      });
    },
    addKeyword() {
      this.editGroup.parameters.push({
        gtrends_keywords_id: "",
        sv: "",
      });
    },
  },
};
</script>
<style scoped>
.outlined-row {
  border: 1px solid #e0e0e0;
  border-radius: 1px;
  padding: 1px;
  margin: 3px;
}
</style>
